import React, { FC, useState } from 'react';
import { useInsuranceLabels } from '../../Utils/Context/labelsContext';
import classNames from 'classnames';
import { ContactForm } from './Components/ContactForm';
import { ReportErrorForm } from './Components/ReportErrorForm';

interface FormContainerProps {
  isAuthenticated: boolean;
}

export const FormContainer: FC<FormContainerProps> = (props) => {
  const [isContactTabVisible, setIsContactTabVisible] = useState<boolean>(true);

  const {
    headings,
  } = useInsuranceLabels();

  const contactFormPanelId = 'insuranceContactForm_Panel';
  const reportErrorFormPanelId = 'insuranceReportErrorForm_Panel';

  return (
    <div className="contactForm">
      <div className="contactForm__tabs" role="tablist" aria-orientation="horizontal">
        <button
          type="button"
          className={classNames('contactForm__tab', { ['contactForm__tab--active']: isContactTabVisible })}
          role="tab"
          aria-selected={isContactTabVisible}
          aria-controls={contactFormPanelId}
          onClick={() => setIsContactTabVisible(true)}
        >
          <h2 className="contactForm__header">
            {false ? headings.helsemailFormHeading : headings.contactFormHeading}
          </h2>
        </button>
        {props.isAuthenticated && (
          <button
            type="button"
            className={classNames('contactForm__tab', { ['contactForm__tab--active']: !isContactTabVisible })}
            role="tab"
            aria-selected={!isContactTabVisible}
            aria-controls={reportErrorFormPanelId}
            onClick={() => setIsContactTabVisible(false)}
          >
            <h2 className="contactForm__header">
              {headings.reportErrorFormHeading}
            </h2>
          </button>
        )}
      </div>
      <div
        className={classNames("contactForm__tabPanel", { ['contactForm__tabPanel--hidden']: !isContactTabVisible })}
        id={contactFormPanelId}
        role="tabpanel"
      >
        <ContactForm />
      </div>
      {props.isAuthenticated && (
        <div
          className={classNames("contactForm__tabPanel", { ['contactForm__tabPanel--hidden']: isContactTabVisible })}
          id={reportErrorFormPanelId}
          role="tabpanel"
        >
          <ReportErrorForm />
        </div>
      )}

    </div>
  )
};
